<ngx-spinner name="spinnerBloquearRemetenteEmail" bdColor="rgba(0, 0, 0, 0.43)"
    template="<img width='250' src='assets/img/brand/GIF_LOADING-MILVUS_v3.gif' />"></ngx-spinner>
<div class="modal-content modal-milvus" *ngIf="!bloqueio">
    <div class="modal-header">
        <h6 class="modal-title" id="modal-title-default">{{titulo_modal}}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()"
            [disabled]="salvandoBloqueio">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="row mb-2" *ngIf="!is_bloquear_email">
            <div class="col">
                <label class="radio-box">
                    <div class="d-flex justify-content-start">
                        <input type="radio" name="cliente" [checked]="true" [value]="'__all__'" [(ngModel)]="cliente"
                            (click)="disableCliente(true)" />
                        <span class="checkmark"></span>
                    </div>
                </label>
                <span>
                    {{'BLOQUEAR' | translate}} {{'EMAIL' | translate}}
                    <strong>{{bloquear_email.bloquear_email.email_cliente}}</strong> {{'PARA_TODOS_CLIENTES'|
                    translate}}
                </span>
            </div>
        </div>
        <div class="row mb-2" *ngIf="!is_bloquear_email">
            <div class="col">
                <label class="radio-box">
                    <div class="d-flex justify-content-start">
                        <input type="radio" name="cliente" [value]="''" [(ngModel)]="cliente"
                            (click)="disableCliente(false)" />
                        <span class="checkmark"></span>
                    </div>
                </label>
                <span>
                    {{'SELECIONAR_CLIENTE' | translate}} {{'PARA_BLOQUEAR_EMAIL'| translate}}
                    <strong>{{bloquear_email.bloquear_email.email_cliente}}</strong>
                </span>
            </div>
        </div>
        <div class="row" *ngIf="is_bloquear_email">
            <div class="form-group col">
                <label [translate]="'EMAIL'"></label>
                <input type="text" class="form-control" [(ngModel)]="bloquear_email.bloquear_email.email_cliente"
                    [disabled]="is_bloquear_email">
            </div>
        </div>
        <div class="row" *ngIf="is_bloquear_email">
            <div class="form-group col">
                <label [translate]="'DESCRICAO'"></label>
                <input type="text" class="form-control" [(ngModel)]="descricao_texto">
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label [translate]="'CLIENTE_'"></label>
                    <select-padrao [entidade]="'selectClientes'" [required]="true" [returnObj]="true"
                        [disabled]="disableClienteSelect" [model]="remetente" [selectModalPequeno]="true"
                        (selectChange)="remetente = $event"></select-padrao>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn badge-pill"
            [ngClass]="is_bloquear_email === true? 'btn-success' : 'btn-danger'" (click)="bloquearLiberarRementente()"
            [disabled]="validBloqueio() || salvandoBloqueio">
            <span>{{(is_bloquear_email)? ('LIBERAR' | translate ): ('BLOQUEAR' | translate)}}</span>
        </button>
    </div>
</div>